export default __webpack_public_path__ + "static/media/community.40032a71.webp";